<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-card elevation="6" class="pa-2">
        <!-- ปุ่มย้อนกลับ -->
        <div class="pa-4">
          <v-btn color="#86bc3a" dark @click="goBack">
            <v-icon left>mdi-arrow-left</v-icon>
            ย้อนกลับ
          </v-btn>
        </div>

        <div v-if="loading_detail === true">
          <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
          </v-sheet>
        </div>
        <div v-else>
          <!-- header -->
          <div class="ma-4 border_card">
            <div class="grid_half pa-4">
              <!-- lots -->
              <div class="d-flex">
                <div class="mr-3 font-weight-bold">ล็อตสินค้า :</div>
                <div>{{ lot_detail.lot_no }}</div>
              </div>
              <div class="grid_flex">
                <div class="mr-3 font-weight-bold">ชื่อสินค้า :</div>
                <div>{{ lot_detail.product_name }}</div>
              </div>
              <!-- date expired -->
              <div class="d-flex">
                <div class="mr-3 font-weight-bold">วันหมดอายุ :</div>
                <div>{{ date }}</div>
              </div>
              <div class="grid_flex">
                <div class="mr-3 font-weight-bold">ซัพพลายเออร์ :</div>
                <div>{{ lot_detail.supplier_name }}</div>
              </div>
            </div>
          </div>

          <!-- data current status -->
          <div class="ma-4 border_card">
            <v-card-title>
              สถานะปัจจุบัน
            </v-card-title>
            <v-data-table 
              :headers="header_date" 
              :items="data_list" 
              :footer-props="footer_Props" 
              hide-default-footer 
              mobile-breakpoint="0">
              <template slot="item" slot-scope="dataDetail">
                <tr>
                  <td>{{ dataDetail.item.sell_name }}</td>
                  <td>{{ dataDetail.item.sell.sum }}</td>
                  <td>{{ dataDetail.item.sell.unit }}</td>
                </tr>
                <tr>
                  <td>{{ dataDetail.item.warehouse_main_name }}</td>
                  <td>{{ dataDetail.item.warehouse_main.sum }}</td>
                  <td>{{ dataDetail.item.warehouse_main.unit }}</td>
                </tr>
                <tr>
                  <td>{{ dataDetail.item.warehouse_expireds_name }}</td>
                  <td>{{ dataDetail.item.warehouse_expireds.sum }}</td>
                  <td>{{ dataDetail.item.warehouse_expireds.unit }}</td>
                </tr>
                <tr>
                  <td>{{ dataDetail.item.warehouse_damage_name }}</td>
                  <td>{{ dataDetail.item.warehouse_damage.sum }}</td>
                  <td>{{ dataDetail.item.warehouse_damage.unit }}</td>
                </tr>
                <tr>
                  <td>{{ dataDetail.item.warehouse_return_name }}</td>
                  <td>{{ dataDetail.item.warehouse_return.sum }}</td>
                  <td>{{ dataDetail.item.warehouse_return.unit }}</td>
                </tr>
                <tr>
                  <td>{{ dataDetail.item.warehouse_dump_name }}</td>
                  <td>{{ dataDetail.item.warehouse_dump.sum }}</td>
                  <td>{{ dataDetail.item.warehouse_dump.unit }}</td>
                </tr>
                <tr>
                  <td>{{ dataDetail.item.warehouse_trash_name }}</td>
                  <td>{{ dataDetail.item.warehouse_trash.sum }}</td>
                  <td>{{ dataDetail.item.warehouse_trash.unit }}</td>
                </tr>
                <tr>
                  <td>{{ dataDetail.item.warehouse_promotion_name }}</td>
                  <td>{{ dataDetail.item.warehouse_promotion.sum }}</td>
                  <td>{{ dataDetail.item.warehouse_promotion.unit }}</td>
                </tr>
              </template>
            </v-data-table>
          </div>

          <!-- history currently -->
          <div class="ma-4 border_card">
            <v-card-title>
              ประวัติการดำเนินการ
            </v-card-title>
            <v-data-table 
              :headers="header_history" 
              :items="log_detail" 
              :footer-props="footer_Props" 
              mobile-breakpoint="0">
              <template slot="item" slot-scope="dataDetail">
                <tr>
                  <td>
                    <div v-if="dataDetail.item.create_at !== null">{{ dataDetail.item.create_at }}</div>
                    <div v-else>-</div>
                  </td>
                  <td>
                    <div v-if="dataDetail.item.detail !== null">{{ dataDetail.item.detail }}</div>
                    <div v-else>-</div>
                  </td>
                  <td>
                    <div v-if="dataDetail.item.quantity !== null">
                      <div class="error--text" v-if="dataDetail.item.quantity < 0">{{ dataDetail.item.quantity }}</div>
                      <div v-if="dataDetail.item.quantity >= 0">{{ dataDetail.item.quantity }}</div>
                    </div>
                    <div v-else>-</div>
                  </td>
                  <td>
                    <div v-if="dataDetail.item.note !== null">{{ dataDetail.item.note }}</div>
                    <div v-else>-</div>
                  </td>
                  <td>
                    <div v-if="dataDetail.item.user_name !== null">{{ dataDetail.item.user_name }}</div>
                    <div v-else>-</div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </div>

        <v-overlay :value="overlay" class="z_index">
          <div class="text-center">
            <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
            ></v-progress-circular>
            <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
          </div>
        </v-overlay>
      </v-card>
    </div>
  </div>
</template>

<script>
import { HTTP } from "@/axios";
import { diffChangeFormat } from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  data() {
    return {
      loading_page: false,
      loading_detail: false,
      date: '',
      overlay: false,
      footer_Props: {
        'items-per-page-text': 'รายการต่อหน้า'
      },
      header_date: [
        {
          text: 'รายการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '500px',
        },
        {
          text: 'จำนวน',
          value: '',
          sortable: false,
          fixed: true,
          width: '250px',
        },
        {
          text: 'หน่วยนับ',
          value: '',
          sortable: false,
          fixed: true,
          width: '250px',
        },
      ],
      header_history: [
        {
          text: 'วันที่',
          value: 'create_at',
          fixed: true,
          width: '140px',
        },
        {
          text: 'รายการ',
          value: 'detail',
          fixed: true,
          width: '300px',
        },
        {
          text: 'จำนวน',
          value: 'quantity',
          fixed: true,
          width: '180px',
        },
        {
          text: 'หมายเหตุ',
          value: 'note',
          fixed: true,
          width: '250px',
        },
        {
          text: 'ผู้ดำเนินการ',
          value: 'user_name',
          fixed: true,
          width: '150px',
        },
      ],
      lot_detail: {},
      log_detail: [],
      data_list: [],
    }
  },
  methods: {
    diffChange: function (value) {
      return diffChangeFormat(value)
    },
    goBack() {
      this.$router.push({ 
        name: 'SearchProductLots',
        query: {
          product_id: this.$route.query.product_id
        }
      })
    },
    async getLotDetail() {
      this.loading_detail = true
      this.overlay = true

      try {
        const response = await HTTP.post('/stocks/lots', {
          id: this.$route.query.id,
          lot_no: this.$route.query.lot_no,
          product_id: this.$route.query.product_id,
        })

        if (response.data.success === true) {
          this.lot_detail = response.data.object.lot_detail
          this.date = this.lot_detail.date_expired
          
          this.data_list = [
            {
              sell_name: 'ขาย',
              sell: response.data.object.sell,
              warehouse_main_name: 'คลังหลัก',
              warehouse_main: response.data.object.warehouse_main,
              warehouse_expireds_name: 'คลังใกล้หมดอายุ',
              warehouse_expireds: response.data.object.warehouse_expireds,
              warehouse_damage_name: 'คลังชำรุด',
              warehouse_damage: response.data.object.warehouse_damage,
              warehouse_return_name: 'คลังรอคืน',
              warehouse_return: response.data.object.warehouse_return,
              warehouse_dump_name: 'คลังรอลดหนี้',
              warehouse_dump: response.data.object.warehouse_reduct,
              warehouse_trash_name: 'คลังทิ้ง',
              warehouse_trash: response.data.object.warehouse_dump,
              warehouse_promotion_name: 'คลังโปรโมชั่น',
              warehouse_promotion: response.data.object.warehouse_promotion,
            }
          ]
          
          this.log_detail = response.data.object.log_detail
        }
      } catch (error) {
        console.error('Error fetching lot detail:', error)
      } finally {
        this.loading_detail = false
        this.overlay = false
      }
    }
  },
  mounted() {
    // ดึงข้อมูลรายละเอียดล็อตเมื่อ component โหลด
    if (this.$route.query.lot_no && this.$route.query.product_id) {
      this.getLotDetail()
    }
  }
}
</script>

<style scoped>
.border_card {
  border: #b3b3b3 solid 1px;
}

.grid_flex {
  display: flex;
}

.grid_half {
  display: grid;
  grid-template-columns: 30% 70%;
  grid-gap: 15px 0;
}

@media only screen and (max-width: 1024px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
</style>